import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box
} from '@mui/material';
import { addLearnerNotes, updateLearnerNotes } from '../../../../../services/mentorServices/ReviewServices';
import { toast } from 'react-toastify';

function AddNoteModal({ open, onClose, selectedNotesTopic, existingNote,fetchReviewTopics}) {
    const [remark, setRemark] = useState('');
    const [errors, setErrors] = useState({ remark: false });
    useEffect(() => {
        if (open) {
            setRemark(existingNote?.track_note || '');
            setErrors({ remark: false });
        }
    }, [open, existingNote]);

    const handleRemarkChange = (e) => {
        setRemark(e.target.value);
        if (e.target.value?.trim()) {
            setErrors({ remark: false });
        }
    };

    const handleSaveNote = async () => {
        if (!remark?.trim()) {
            setErrors({ remark: true });
            toast.error('Please enter a note before saving.');
            return;
        }
        try {
            if (existingNote) {
                const payload = {
                    track_note: remark
                };
                const response = await updateLearnerNotes(existingNote.id,payload);
                toast.success(response?.data?.message || 'Note updated successfully.');
                
            } else {
                const obj = {
                    learnerId: selectedNotesTopic.learner_id,
                    MakerPlanId: selectedNotesTopic.makerplanID,
                    ModuleId: selectedNotesTopic.moduleID,
                    TopicId: selectedNotesTopic.topicID,
                    track_note: remark
                }
                const response = await addLearnerNotes(obj);
                toast.success(response?.data?.message || 'Note added successfully.');
            }

            setRemark('');
            onClose();
            fetchReviewTopics()
        } catch (error) {
            const errMsg =
                error?.response?.data?.message ||
                error?.message ||
                'Failed to save note. Please try again.';
            toast.error(errMsg);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: 4, p: 1 } }}>
            <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
                {existingNote ? '✏️ Edit Note' : `📝 Add Note for - ${selectedNotesTopic?.topic_Name}`}
            </DialogTitle>

            <DialogContent>
                <Box mt={1}>
                    <TextField
                        fullWidth
                        multiline
                        minRows={4}
                        variant="outlined"
                        value={remark}
                        onChange={handleRemarkChange}
                        error={!!errors.remark}
                        helperText={errors.remark ? 'Note is required*' : ''}
                        placeholder="Enter your notes here..."
                        sx={{ '& .MuiInputBase-root': { overflow: 'hidden !important' }, '& textarea': { overflow: 'hidden !important', resize: 'none !important' } }}
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} variant="outlined" color="secondary">
                    Cancel
                </Button>
                <Button
                    onClick={handleSaveNote}
                    variant="contained"
                    disabled={!remark?.trim()}
                    sx={{ fontWeight: 'bold', boxShadow: 1 }}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AddNoteModal;
